<template>
  <div ref="component"></div>
</template>

<script>
  const component = 'SaveOrder';
  import setInputValue from '../utils/setInputValue';

  export default {
    props: {
      saveTo: String
    },
    data() {
      return {}
    },
    mounted() {
      console.log({mounted: component});

      const vueComponent = $(this.$refs.component);
      const questionContainer = vueComponent.closest('.question-container');
      const vue = this;

      $(function () {
        let ids = [];
        $('tr', questionContainer).map(function () {
          ids.push($(this).attr('id'));
        });
        ids = ids
          .map(id => {
            if (!id) return null;
            const found = id.match(/SQ[0-9]+/);
            return found[0];
          })
          .filter(id => id)
          .join(', ');

        console.log({component, ids});
        setInputValue(vue.saveTo, ids);
      });
    },
  }
</script>
